export default __webpack_public_path__ + "static/media/parallels.c7c934a4.png";